import React from 'react';

function Logo({ animate, height, dark }: { animate?: boolean; height?: string; dark?: boolean }) {
  return (
    <svg
      version="1.1"
      xmlns="https://www.serif.com/"
      viewBox="0 0 116.4 53.7"
      className={`${height ? height : 'h-12 p-2 xl:h-16'}`}
    >
      <g>
        <circle className={`fill-gls-logo-yellow ${animate ? 'animate-bounce' : ''}`} cx="104.2" cy="38.5" r="5.8" />
        <g transform="matrix(1,0,0,1,-94.79,-92.8)">
          <path
            className={`${dark ? 'fill-gls-logo-blue' : 'fill-white'}`}
            d="M117.9,118.5v7.6h6.3c-0.9,1.4-3,2.2-4.4,2.2c-4.7,0-7.1-2.7-7.1-8.2c0-6,3.1-9.1,9.3-9.1
                        c2.5,0,5.7,0.6,9.1,1.7v-9.1c-1-0.4-2.5-0.8-4.5-1.1c-1.7-0.3-3.5-0.5-5.3-0.5c-6.2,0-11,1.7-14.7,5s-5.5,7.8-5.5,13.4
                        c0,5.2,1.4,9.2,4.3,12.2c2.8,3,6.7,4.5,11.5,4.6c4.9,0,9.3-2.5,10.8-5.7l0,5.1h7v-18.2H117.9z"
          />
        </g>
        <g transform="matrix(1,0,0,1,-94.79,-92.8)">
          <path className={`${dark ? 'fill-gls-logo-blue' : 'fill-white'}`} d="M138.2,136.7v-34h10.9v25.2H161v8.9H138.2z" />
        </g>
        <g transform="matrix(1,0,0,1,-94.79,-92.8)">
          <path
            className={`${dark ? 'fill-gls-logo-blue' : 'fill-white'}`}
            d="M164.5,135.8v-9.3c1.6,0.5,3.5,0.9,5.6,1.3s4,0.6,5.5,0.6c2.7,0,4-0.7,4-1.8c0-0.8-0.4-1.1-2.4-1.6l-3.8-0.9
                        c-6.5-1.5-9.5-4.7-9.5-10.3c0-3.6,1.3-6.5,3.8-8.7c2.5-2.1,6-3.1,10.4-3.1c3,0,7.7,0.6,10.5,1.3v8.9c-1.5-0.4-3.2-0.8-5.4-1.1
                        c-2.1-0.3-3.8-0.5-5-0.5c-2.3,0-3.6,0.7-3.6,1.8c0,0.7,0.6,1.2,1.9,1.5l4.4,1c6.4,1.5,9.4,4.8,9.4,10.5c0,3.6-1.3,6.4-3.9,8.5
                        c-2.6,2.1-6.2,3.1-10.8,3.1C171.4,137.2,167,136.6,164.5,135.8z"
          />
        </g>
      </g>
    </svg>
  );
}

export default Logo;
